import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { QuestionGroup } from 'src/app/interfaces/question';

type SortType = 'famous' | 'latest';

@Component({
  selector: 'question-group-select',
  templateUrl: './question-group-select.component.html',
  styleUrls: ['./question-group-select.component.scss'],
})
export class QuestionGroupSelectComponent implements OnInit {

  constructor() { }

  @Input() questionGroupMainImageUrl = '';
  @Input() questionGroups: QuestionGroup[] = [];
  @Input() isSortable = true;
  @Output() questionGroupSelected = new EventEmitter<QuestionGroup>();
  sortOption: SortType = 'latest';


  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.questionGroups.currentValue !== undefined) {
      this.questionGroups = this.sort(this.questionGroups, this.sortOption);
    }
  }
  
  toggleSort(event: Event): void {
    const value = (event.target as any).value;
    this.questionGroups = this.sort(this.questionGroups, value);
  }

  onClickTheme(selectedGroup: QuestionGroup): void {
    this.questionGroupSelected.emit(selectedGroup);
  }

  private sort(data: QuestionGroup[], type: SortType): QuestionGroup[] {
    switch (type) {
      case 'famous':
        return data.sort((a, b) => a.playCount < b.playCount ? 1 : -1);
      case 'latest':
        return data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);
    }
  }

}
